export type DashboardTypes = 'pull-requests' | 'issues' | 'repo-issues' | 'repositories'

export const dashboardTypeLabels: Record<DashboardTypes, string> = {
  'pull-requests': 'pull requests',
  issues: 'issues',
  'repo-issues': 'issues',
  repositories: 'repositories',
}

export const dashboardTypeLabelSingular: Record<DashboardTypes, string> = {
  'pull-requests': 'pull request',
  issues: 'issue',
  'repo-issues': 'issue',
  repositories: 'repository',
}
